import { AsyncPipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { Component, inject, Input, OnInit } from '@angular/core';
import { RecentItem } from '@compiere-ws/models/compiere-recent-item';
import { RecentItemsManagerService } from '@iupics-manager/managers/recent-items-manager/recent-items-manager.service';
import { UICreatorService } from '@iupics-manager/managers/ui-creator/ui-creator.service';
import { WorkspaceService } from '@web-desktop/components/workspace/components/workspace-ui/workspace.service';
import { IupicsMenuType } from '@web-desktop/models/menu-item-ui';
import { map, Observable } from 'rxjs';
import { AbstractWidgetComponent } from '../../abstract-widget.component';

// display only: "Commande: CVW10053" -> type "Commande" + ref "CVW10053"
interface RecentItemRow {
  item: RecentItem;
  icon: string;
  type: string;
  ref: string;
}

@Component({
  selector: 'iu-recent-item-widget-ui',
  templateUrl: './recent-item-widget-ui.component.html',
  styleUrls: ['./recent-item-widget-ui.component.scss'],
  standalone: true,
  imports: [AsyncPipe, TranslateModule],
})
export default class RecentItemWidgetUiComponent extends AbstractWidgetComponent implements OnInit {
  /** list (card, side column) or chips (a row of the last records on the dashboard) */
  @Input() variant: 'list' | 'chips' = 'list';
  @Input() maxChips = 10;
  recentItems$: Observable<RecentItem[]>;
  rows$: Observable<RecentItemRow[]>;
  #workspaceService = inject(WorkspaceService);

  constructor(
    private riManager: RecentItemsManagerService,
    uiCreatorService: UICreatorService
  ) {
    super(uiCreatorService);
  }

  ngOnInit(): void {
    this.updateWidget();
  }

  updateWidget(): void {
    this.recentItems$ = this.riManager.getRecentItems();
    this.rows$ = this.recentItems$.pipe(map((items) => (items ?? []).map((item) => this.toRow(item))));
  }

  private toRow(item: RecentItem): RecentItemRow {
    const name = item?.name ?? '';
    const sep = name.indexOf(': ');
    return {
      item,
      // recent items are windows: generic window icon unless the server sent an icomoon class
      icon: item?.icon?.startsWith('icon-') ? item.icon : 'icon-window-2',
      type: sep > 0 ? name.substring(0, sep) : '',
      ref: sep > 0 ? name.substring(sep + 2) : name,
    };
  }

  openTab(event: Event, item: unknown): void {
    const recentItem = item as RecentItem;
    event.stopPropagation();
    const source = {
      id: recentItem.entityKey,
      menuType: IupicsMenuType.WINDOW,
    };
    this.#workspaceService.openTargetSearchEmt.emit({
      zoomInfo: null,
      cat: { id: recentItem.entityID },
      source,
      ctx: null,
    });
  }
}
